export const scrollToContent = (id: string) => document.getElementById(id)?.scrollIntoView();
